import React, { FC, useCallback } from "react";

import Form from "antd/es/form";
import { useForm } from "antd/es/form/Form";
import { defineMessages, useIntl } from "react-intl";

import FormFields from "@app/component/FormFields";
import { IWizardStep, StandardStep } from "@app/component/wizard";
import ModeSwitch from "@app/scene/map/components/LeadFinderMode/components/AddRecordsWizard/components/ModeSwitch";
import Routes from "@app/scene/map/components/LeadFinderMode/components/AddRecordsWizard/components/Routes";
import useStepTitle from "@app/scene/map/components/LeadFinderMode/components/AddRecordsWizard/useStepTitle";

import AddRecordsWizardState from "../../AddRecordsWizardState";

import styles from "./SelectTypeStep.module.scss";

const messages = defineMessages({
  routes: {
    id: "map.tool.leadFinder.addRecords.routes.label",
    defaultMessage: "Add leads to the following route(s)",
    description: "Add leads to the following route(s)",
  },
  subtitle: {
    id: "map.tool.leadFinder.addRecords.selectTypeStep.subtitle",
    defaultMessage: "Import leads as",
    description: "Lead Finder - Import leads as title",
  },
});

interface SelectTypeStepProps extends IWizardStep<AddRecordsWizardState> {}

type FormFields = Pick<AddRecordsWizardState, "entityType" | "routeIdsOrRoutePayloads">;

const SelectTypeStep: FC<SelectTypeStepProps> = ({
  onCancel,
  onGoForward,
  onSetState,
  state,
  ...props
}) => {
  const intl = useIntl();
  const [form] = useForm<FormFields>();

  const title = useStepTitle();

  const formInitialValues: FormFields = {
    entityType: state.entityType,
    routeIdsOrRoutePayloads: state.routeIdsOrRoutePayloads,
  };

  const handleFinish = useCallback(
    (formValues: FormFields) => {
      onSetState(() => ({ ...formValues }));
      onGoForward();
    },
    [onGoForward, onSetState]
  );

  return (
    <StandardStep
      backButtonHidden
      onCancel={onCancel}
      onGoForward={form.submit}
      title={title}
      {...props}
    >
      <div className={styles.content}>
        <div className={styles.subtitle}>{intl.formatMessage(messages.subtitle)}</div>
        <Form
          form={form}
          initialValues={formInitialValues}
          layout="vertical"
          onFinish={handleFinish}
        >
          <Form.Item name="entityType">
            <ModeSwitch />
          </Form.Item>
          <Form.Item label={intl.formatMessage(messages.routes)} name="routeIdsOrRoutePayloads">
            <Routes entityType={state.entityType} />
          </Form.Item>
        </Form>
      </div>
    </StandardStep>
  );
};

export default SelectTypeStep;
